import { Grid, useMediaQuery } from "@mui/material";
import { Visibility } from "@mui/icons-material";

import { ListAction, ListActions, StyledListWrapper, StyledPagination } from "@framework/styled";
import { IRaffleToken } from "@framework/types";
import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useDialogView, useFetchQuery } from "@dzambalaorg/react-hooks";
import { List } from "@dzambalaorg/ui-kit";

import { RaffleRewardButton } from "../../../../../components/buttons";
import { RaffleTokenSearchForm } from "./search";
import { RaffleTokenDialogView } from "./view";

const RAFFLE_TICKETS_TOKEN_URL = "/raffle/ticket/tokens";
const RAFFLE_TICKETS_TOKEN_DIALOG_KEY = "raffleTicketTokens";

export const RaffleTicketTokenList = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IRaffleToken>
  >(RAFFLE_TICKETS_TOKEN_URL, { enableInfiniteScroll: isMd });

  const { viewItem, handleView, viewDialogUniqueKey, closeViewDialog, viewMode } = useDialogView<IRaffleToken>();

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "raffle", "raffle.tokens"]} />

      <PageHeader message="pages.raffle.tokens.title" />

      <RaffleTokenSearchForm />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading}>
          {allRows.map(token => (
            <List.Item key={token.id}>
              <List.ItemText sx={{ width: 0.2 }}>{token.round?.contract?.title}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>{token.id}</List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>
                {"Round #"}
                {token.round.roundId}
              </List.ItemText>
              <List.ItemText sx={{ width: 0.2 }}>{token.round.number === token.tokenId ? "winner" : ""}</List.ItemText>
              <ListActions>
                <RaffleRewardButton token={token} />
                <ListAction
                  onClick={handleView(RAFFLE_TICKETS_TOKEN_DIALOG_KEY, token, "view")}
                  message="form.tips.view"
                  icon={Visibility}
                />
              </ListActions>
            </List.Item>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}

      <RaffleTokenDialogView
        onCancel={closeViewDialog}
        onConfirm={closeViewDialog}
        open={viewDialogUniqueKey === `${RAFFLE_TICKETS_TOKEN_DIALOG_KEY}.${viewMode}`}
        viewItem={viewItem}
      />
    </Grid>
  );
};
